import { createSlice } from '@reduxjs/toolkit';

import initialState from './initialState';

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlert(state, { payload }) {
      state.message = payload.message;
      state.type = payload.type;
    },
    clearAlert() {
      return initialState;
    },
  },
});

export const {
  setAlert,
  clearAlert,
} = alertSlice.actions;

export default alertSlice.reducer;
